/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

const { state } = store( 'gt/promotions', {
	state: {
		promotions: [],
		promotionsLinks: [],
	},
	actions: {
		async fetchPromotions() {

			const context = getContext();
			const response = await fetch(
				'/wp-json/geek-tonic/v1/promotions?lang=' +
				  context.lang +
				  '&cacheBust=' +
				  Date.now()
			  );			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}
			const data = await response.json();
			if (data.success) {
				state.promotionsLinks = data.promotions.filter(promotion => promotion.link != '');
				state.promotions = data.promotions.filter(promotion => promotion.link == '');
				
				context.hasPromo = state.promotions.length > 0 || state.promotionsLinks.length > 0;

				const swiper = document.querySelector('.wp-block-gt-gt-fse-promotions .swiper').swiper;
				if (swiper) {
					setTimeout(() => swiper.update(), 1000);
				}
			} else {
				setError('Failed to fetch promotions.');
			}
		}
	},
	callbacks: {
		/**
		 * Callback to run when promotions change.
		 */
		promotionsChanged(newPromotions) {
			console.log('Promotions updated:', newPromotions);
		},
	},
} );
